import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../stili/NavbarGenitore.css";

const gruppiGenitore = [
  {
    posizione: "Mio Profilo",
    voci: [
      { label: "I Miei Dati", path: "/gestionale2/aggiorna-genitore" },
      { label: "Modifica Account", path: "/gestionale2/aggiorna-account-genitore" }
    ]
  },
  {
    posizione: "Figli",
    voci: [
      { label: "Giocatore", path: "/gestionale2/aggiorna-figli" },
      { label: "Presenza Allenamento", path: "/gestionale2/presenza-genitore" },
      { label: "Presenza Gara", path: "/gestionale2/presenze-gara-genitore"}
    ]
  },
  {
    posizione: "Documenti",
    voci: [
      { label: "Upload Documenti", path: "/gestionale2/documenti" }
    ]
  }
];

export default function NavbarGenitore() {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <aside className="navbar-genitore">
      <div className="navbar-genitore-shell">
        <h3 className="navbar-genitore-title">Gestionale Genitore</h3>

        {gruppiGenitore.map((gruppo) => (
          <div className="navbar-genitore-group" key={gruppo.posizione}>
            <h4 className="navbar-genitore-group-title">{gruppo.posizione}</h4>

            <div className="navbar-genitore-links">
              {gruppo.voci.map((voce) => (
                <button
                  key={voce.path}
                  type="button"
                  className={
                    location.pathname === voce.path
                      ? "navbar-genitore-link active"
                      : "navbar-genitore-link"
                  }
                  onClick={() => navigate(voce.path)}
                >
                  {voce.label}
                </button>
              ))}
            </div>
          </div>
        ))}
      </div>
    </aside>
  );
}